import { ISurveyEvalResponse } from "src/api/types";

export const sortByDate = (a: ISurveyEvalResponse, b: ISurveyEvalResponse) => {
  if (a.startDate > b.startDate) {
    return 1;
  } else if (a.startDate < b.startDate) {
    return -1;
  } else {
    return 0;
  }
};



// WEBPACK FOOTER //
// ./src/features/director/pages/SurveyDataCenter/hooks/utils/sortByDate/sortByDate.ts